import { AppBar, Box, styled, Toolbar } from '@mui/material';
import { CandidateNavBarLogoContainer } from './CandidateNavBarLogoContainer';
import { CandidateNavbarUserDropdownMenu } from '../../UserNavigationMenus/CandidateMenus/CandidateNavbarUserDropdownMenu';
import { getConnectUrlPath } from 'features/Connect/features/JobDiscovery/utils';
import { useConnectContext } from 'features/Connect/features/Context/ConnectContextProvider';
import { useStateParam } from 'features/Connect/features/Context/ConnectStateCodeContextProvider';
import auth from 'utils/auth';
import { CandidateNavBarButtonGroupContainer } from './CandidateNavBarButtonGroupContainer';
import { useRouteMatch } from 'react-router-dom';
import {
  candidatePortalRedirectUrls,
  connectRedirectUrls,
  nimbleConnectUrlFlag,
} from 'utils/constants';
import { AuthenticatedAdminModal } from 'features/Connect/components/Modals/AuthenticatedAdminModal/AuthenticatedAdminModal';
import { ConnectAuthenticatedAdminModalDataTestIds } from 'data-testids/ConnectDataTestIds';

export const CandidateNavBar: React.FC = () => {
  const jobBoardState = useStateParam();
  const connectUrlPath = getConnectUrlPath(jobBoardState);
  const isConnectLogin = useRouteMatch({ path: connectRedirectUrls.LOGIN, exact: true });
  const isConnectSignup = useRouteMatch({ path: connectRedirectUrls.SIGN_UP, exact: true });
  const isCandidatePortal = useRouteMatch({
    path: candidatePortalRedirectUrls.CANDIDATE_PORTAL,
  });
  const { candidateMatches, isAuthenticatedAdminModalOpen } = useConnectContext();
  const user = auth.getUser();
  const isOnConnect = useRouteMatch({ path: `/${nimbleConnectUrlFlag}` });

  return (
    <NavbarAppBar $isConnectRoute={!!isOnConnect}>
      <NavbarContainer
        maxWidth={!isConnectLogin && !isConnectSignup && !isCandidatePortal ? '1130px' : 'auto'}
      >
        <NavbarToolbar disableGutters>
          <CandidateNavBarLogoContainer
            jobBoardState={jobBoardState}
            connectUrlPath={connectUrlPath}
          />
          <Box>
            {user ? (
              <CandidateNavbarUserDropdownMenu user={user} candidateMatches={candidateMatches} />
            ) : (
              <CandidateNavBarButtonGroupContainer />
            )}
          </Box>
        </NavbarToolbar>
      </NavbarContainer>
      {isAuthenticatedAdminModalOpen && (
        <AuthenticatedAdminModal
          jobBoardState={jobBoardState}
          district={user?.profile?.district}
          dataTestId={ConnectAuthenticatedAdminModalDataTestIds.NAVBAR_ADMIN_MODAL}
        />
      )}
    </NavbarAppBar>
  );
};

const NavbarAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== '$isConnectRoute',
})<{ $isConnectRoute: boolean }>(({ theme, $isConnectRoute }) => ({
  position: $isConnectRoute ? 'fixed' : 'static',
  top: 0,
  background: theme.palette.white.main,
  height: '80px',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: 'none',
  borderBottom: `1px solid ${theme.palette.gray.light}`,
  padding: theme.spacing(0, 6),

  [theme.breakpoints.down('lg')]: {
    height: '64px',
    padding: theme.spacing(0, 2),
  },
}));

const NavbarContainer = styled(Box)(() => ({
  justifyContent: 'space-between',
  width: '100%',
}));

const NavbarToolbar = styled(Toolbar)(() => ({
  width: '100%',
  justifyContent: 'space-between',
  justifySelf: 'center',
}));
